import { render, staticRenderFns } from "./VPageTitle.vue?vue&type=template&id=5491e704&"
import script from "./VPageTitle.vue?vue&type=script&lang=js&"
export * from "./VPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports